<template>
  <div :class="{'hashead hasservice':!isPC}">
    <div class="loading" v-if="newsDetail.length==0"><i class="el-icon-loading"></i></div>
    <LeaveTel ref="LeaveTel" :service="!isPC" :estate="[newsDetail.estate.callPhone2,newsDetail.estate.pkId,newsDetail.estate.name,newsDetail.estate.pkId?'楼盘动态':'资讯']" v-if="newsDetail.length!=0"></LeaveTel>
    <Header v-if="isPC"></Header>
    <WapHeader :title="$route.query.name" v-if="!isPC" :showhome="true"></WapHeader> 
    <div class="box">
      <div class="news" v-if="newsDetail.infmt">
        <h3 class="ntitle" v-html="newsDetail.infmt.title"></h3>
        <p class="ntime"><slot v-if="newsDetail.infmt.author">作者：{{newsDetail.infmt.author}}　</slot><slot v-if="newsDetail.infmt.issueTime">更新时间：{{newsDetail.infmt.issueTime}}</slot></p>
        <div class="ncontent" v-html="newsDetail.infmt.content"></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/public/Header'
import WapHeader from '@/components/public/WapHeader'
import Footer from '@/components/public/Footer'
import LeaveTel from '@/components/public/LeaveTel'
export default {
  name: 'newsdetail',
  components: {
    'Header': Header,
    'WapHeader': WapHeader,
    'Footer': Footer,
    'LeaveTel':LeaveTel,
  },
  props: {
    bcenter: Object,
  },
  data() {
    return {
      isPC: this.$store.state.isPC,
      newsDetail: [],
    }
  },
  mounted() {
    this.getNewsDetail()
  },
  methods: {
    getNewsDetail() {
      this.$http.get('/api/estate/getInformationData?infmtId='+this.$route.query.id).then((response) => {
        this.newsDetail = response.data.result;
        this.getSignatureShare();
      }).catch((response) => {
        console.log(response)
      })
    },
    // 微信获取密钥分享
    getSignatureShare(){
      var imgUrl = '';
      if(this.newsDetail.infmt.content.search('src="') != -1){
        // 获取图片地址：截取文本字符串中src=" 到 "之间的字符串
        imgUrl  = this.newsDetail.infmt.content.match(/src="(\S*)"/)[1];
      }
      var shareObj = {
        link: window.location.href,
        title: document.title + '-' + this.$route.query.name,
        desc: this.newsDetail.infmt.shortTitle,
        imgUrl: imgUrl,
        logoIndex: this.$store.state.domainIndex
      };
      this.$http.get('/api/wechat/getSignatureInfo?url='+shareObj.link).then((response)=>{
        if(response && response.data.result){
          this.share.weixinShare(shareObj, response.data.result);
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
  },
  computed: {
    listenIsPC() {
      return this.$store.state.isPC;
    }
  },
  watch: {
    listenIsPC: function(boo) {
      this.isPC = this.$store.state.isPC;
    }
  },
}

</script>
<style scoped>
.news {padding:20px 15px 5px;background:#fff;}
.ntitle {font-size:20px;line-height:28px;padding:3px 0;}
.ntime {font-size:13px;line-height:20px;color:#777;padding:5px 0;}
.ncontent{line-height:20px;font-size:14px;color:#555;padding:10px 0;}
.ncontent>>>img{display:block;width:100%;}
.ncontent>>>p{text-indent:2em;padding:5px 0;}
@media (min-width:769px){
  .news{padding:30px 0 5px;}
  .ntitle {font-size:24px;line-height:30px;padding:10px 0;}
  .ncontent>>>p{line-height:25px;font-size:15px;}
}
</style>



// WEBPACK FOOTER //
// src/components/NewsDetail.vue